<div class="h-100 single-report-page">
    <app-admin-report [columns]="customerReport" [hasFilters]="true" [apiUrl]="customerReportAPI"
                      reportTitle="ADMINISTRATION.CUSTOMER_PACKAGES_SUMMARY_REPORT_TITLE"
                      [statics]="customerReportStatistics">
    </app-admin-report>
</div>